export const TITLES_FASES_ATUACAO_CRUD_USUARIO = {
  fasesUsuario: 'Fases de Atuação do Usuário',
  fasesUsuarioComissoes: 'Fases de Atuação do Usuário e suas Comissões',
};

export const TITULO_FASES = 'Fase';
export const TITULO_COMISSAO = 'Comissão';
export const EXCLUIR_TOOLTIP = 'Excluir fase';
export const ADICIONAR_TOOLTIP = 'Adicionar fase';
